// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1ZV6A","Label":"Input_Label__Z3qFK","InputElement":"Input_InputElement__30BIr","Invalid":"Input_Invalid__2cH5Z"};